import { TaxRate as InvoiceTaxRate, ItemUnit } from '@dreryk/egabinet-invoice-frontend-api';
import { MedicalServicePerformableByPractitionerSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';

export type InvoiceItemsTableBean = {
   invoiceParameters: {
      nameEditable: boolean | undefined;
      nameForInvoicing: string | null;
      nameForReceipt: string | null;
      rowAddedManually: boolean | undefined;
      unitDefaultPrice: number | null;
   };
   name: string | MedicalServicePerformableByPractitionerSimple | null;
   quantity: number | null;
   taxRate: InvoiceTaxRate | null;
   unit: ItemUnit | null;
   unitPrice: number | null;
};

export enum MedicalServiceTaxRateMap {
   ZW = 'ZW',
   ZERO = 'ZERO',
   REDUCED = 'REDUCED',
   STANDARD = 'STANDARD',
}
